module.exports = __webpack_public_path__ + "static/media/branding-img27.4478f7f0.jpg";